import "./NewsRow.css";

const NewsRow = ({ title, articles }) => {
  return (
    <div className="newsRow">
      <h2 className="rowTitle">{title}</h2>

      <div className="rowCards">
        {articles?.map((item, index) => (
          <a
            key={index}
            href={item.url}
            target="_blank"
            rel="noreferrer"
            className="newsCard"
          >
            <img
              src={item.image || "https://via.placeholder.com/300x180?text=News"}
              alt={item.title}
            />
            <div className="cardOverlay">
              <p>{item.title}</p>
            </div>
          </a>
        ))}
      </div>
    </div>
  );
};

export default NewsRow;
